// import React, { useState } from "react";
// import { Drawer, Tabs } from "antd";
// import ScheduleDetailsTab from "./ScheduleDetailsTab";
// import ScheduleEditTab from "./ScheduleEditTab";
// import { CloseOutlined } from "@ant-design/icons";

// const { TabPane } = Tabs;

// const ScheduleDetailsDrawer = ({ open, onClose, schedule }) => {
//   const [isEdit, setIsEdit] = useState(false);

//   return (
//     <Drawer
//       placement="right"
//       width={592}
//       open={open}
//       maskClosable={true}
//       keyboard={true}
//       destroyOnClose
//       onClose={() => {
//         setIsEdit(false);
//         onClose();
//       }}
//       closeIcon={
//         <CloseOutlined 
//           style={{ 
//             fontSize: 20, 
//             color: '#999999',
//             padding: 8
//           }} 
//         />
//       }
//       headerStyle={{
//         padding: '16px 16px 0 24px',
//         border: 'none',
//         minHeight: 'auto'
//       }}
//       bodyStyle={{ 
//         padding: 0
//       }}
//       title={null}
//     >
//       <Tabs 
//         defaultActiveKey="details"
//         style={{
//           marginTop: 0
//         }}
//         tabBarStyle={{
//           margin: 0,
//           padding: '16px 24px 0',
//           borderBottom: '1px solid #E6E6E6'
//         }}
//         className="schedule-drawer-tabs"
//       >
//         <TabPane tab="Details" key="details">
//           {!isEdit ? (
//             <ScheduleDetailsTab
//               schedule={schedule}
//               onEdit={() => setIsEdit(true)}
//             />
//           ) : (
//             <ScheduleEditTab
//               schedule={schedule}
//               onCancel={() => setIsEdit(false)}
//               onSave={(payload) => {
//                 ("SAVE PAYLOAD 👉", payload);
//                 setIsEdit(false);
//               }}
//             />
//           )}
//         </TabPane>

//         <TabPane tab="Resources" key="resources">
//           <div style={{ padding: 24 }}>Resources content</div>
//         </TabPane>

//         <TabPane tab="Quizzes" key="quizzes">
//           <div style={{ padding: 24 }}>Quizzes content</div>
//         </TabPane>

//         <TabPane tab="Attendance" key="attendance">
//           <div style={{ padding: 24 }}>Attendance content</div>
//         </TabPane>
//       </Tabs>

//       <style jsx global>{`
//         .schedule-drawer-tabs .ant-tabs-nav {
//           margin-bottom: 0 !important;
//         }

//         .schedule-drawer-tabs .ant-tabs-tab {
//           padding: 12px 0 !important;
//           margin-right: 40px !important;
//           font-family: 'Roboto', sans-serif !important;
//           font-size: 16px !important;
//           font-weight: 400 !important;
//           color: #6B6B6B !important;
//         }

//         .schedule-drawer-tabs .ant-tabs-tab:hover {
//           color: #594099 !important;
//         }

//         .schedule-drawer-tabs .ant-tabs-tab-active .ant-tabs-tab-btn {
//           color: #594099 !important;
//           font-weight: 500 !important;
//         }

//         .schedule-drawer-tabs .ant-tabs-ink-bar {
//           background: #594099 !important;
//           height: 3px !important;
//         }

//         .schedule-drawer-tabs .ant-tabs-nav::before {
//           border-bottom: none !important;
//         }

//         .schedule-drawer-tabs .ant-tabs-content-holder {
//           overflow-y: auto;
//         }

//         .ant-drawer-header {
//           position: absolute;
//           right: 0;
//           top: 0;
//           z-index: 10;
//           background: transparent;
//           border: none;
//           padding: 16px !important;
//         }

//         .ant-drawer-header-title {
//           flex-direction: row-reverse;
//         }

//         .ant-drawer-close {
//           margin: 0 !important;
//           padding: 0 !important;
//         }
//       `}</style>
//     </Drawer>
//   );
// };

// export default ScheduleDetailsDrawer;

import React, { useState, useEffect, useLayoutEffect, useMemo } from "react";
import moment from "moment";
import { Drawer, Tabs } from "antd";
import ScheduleDetailsTab from "./ScheduleDetailsTab";
import ScheduleEditTab from "./ScheduleEditTab";
import ResourcesPanel from "./ResourcesPanel";
import ResourceAddForm from "./ResourceAddForm";
import QuizzesPanel from "./QuizzesPanel";
import { getSchedulePermissions, ACCESS, ATTENDANCE } from './schedulePermissions';
import StudentListComponent from "./StudentList";
import SavingModal from "../../components/SavingModal";
import { CloseOutlined, LeftOutlined } from "@ant-design/icons";
import { connect } from 'react-redux';
import {
  subjectFilter,
  fetchClasslist,
  fetchAdminChapterFilter,
  fetchFilterTopic,
  postCreateTopic,
  uploadBlock2,
  MergeChunk,
  uploadCompleted2,
  uploadlecturenotes,
  removemodel,
  updateCurrentSub,
  updateCurrentStd,
  fetchAdminLibraryData,
  updateSetType,
  setBroadcastQuizzes,
  fetchBroadcastQuizzes,
  deleteBroadcastQuiz,
  postDeleteSingleQuiz,
  postDeleteAllQuizzes,
  patchBroadcastQuizPublish,
  patchResourceTitle,
  deleteResourceContent,
  postDeleteAllResources,
  getStorageDetails,
} from 'actions/digitalLibrary';
import { useHistory } from 'react-router';
import Notification from "../../services/Notification";
import { Api } from "../../services";
import Axios from 'axios';
import fileDownload from 'js-file-download';
import { drawerBooleanState, fetchSchedule } from "actions/schedule";
import { EventRegister } from 'react-native-event-listeners';
import { publishBroadcastRecordings, getRecordings, setCurrentRecordingPath, deleteBroadcastRecording, BroadcastRecordingEdit, uploadRecordingChunk, mergeRecordingChunks, updateRecordingCount } from "actions/broadcast";
import { store } from "App";
import { getVideoDuration } from "services/videoDuration";
import { getVideoSize } from "services/videoSize";
import { getReplacedRecording, saveReplacedRecording, clearReplacedRecording } from "services/recordingStorage";

const { TabPane } = Tabs;

const ScheduleDetailsDrawer = ({
  open,
  onClose,
  schedule,
  // Redux state
  subjects,
  getStdList,
  getChaptersList,
  topicList,
  adminLibraryList,
  broadcastQuizzes: storeQuizzes,
  selectedTopic,
  selectedChapter,
  // Redux actions
  subjectFilter,
  fetchClasslist,
  fetchAdminChapterFilter,
  fetchFilterTopic,
  postCreateTopic,
  uploadBlock2,
  MergeChunk,
  uploadCompleted2,
  uploadlecturenotes,
  removemodel,
  updateCurrentSub,
  updateCurrentStd,
  fetchAdminLibraryData,
  updateSetType,
  setBroadcastQuizzes,
  fetchBroadcastQuizzes,
  deleteBroadcastQuiz,
  postDeleteSingleQuiz,
  postDeleteAllQuizzes,
  patchBroadcastQuizPublish,
  patchResourceTitle,
  deleteResourceContent,
  postDeleteAllResources,
  sizeOfContents,
  getStorageDetails,
  togglePageLoader,
  pageLoader,
  isCompletedClass,
  isScheduledClass,
  isOngoingClass,
  // `access` used to be threaded from here into ScheduleDetailsTab. It never had any
  // effect: that component is connect()ed and read its own `access` out of redux, which
  // overrides an incoming prop. It now derives the right from the role x privilege
  // matrix itself, so there is nothing to pass down.
  drawerValue,
  drawerBooleanState,
  user,
  currentDate,
  publishBroadcastRecordings,
  BroadcastRecordingEdit,
  getRecordings,
  setCurrentRecordingPath,
  fetchSchedule,
  deleteBroadcastRecording,
  uploadRecordingChunk,
  mergeRecordingChunks,
  updateRecordingCount
}) => {


  const handlePublishResource = (id, type) => {
    if (type === 'recording' || type === 'class-recording') {
      togglePageLoader(true);
      const currentScheduleId = schedule?.occurrenceId || schedule?.occurrence_id || schedule?.occuranceId || schedule?.id || schedule?.scheduleId;
      publishBroadcastRecordings(currentScheduleId, true, () => togglePageLoader(false), () => {
        togglePageLoader(false);
        setRecordingPublished(true);
        fetchAdminLibraryData(() => {}, { occurrenceId: currentScheduleId });
        // The recording's `published` flag also lives on the schedule occurrence itself
        // (schedule.published), so the schedule list does need refreshing for other views.
        // This used to call fetchSchedule() first, which always pulls TODAY's list from
        // /schedule-new/ (its `date` param is dead - never used in the request) and
        // overwrites the same scheduleList slice the date-filtered Schedule page cards
        // render from. For a class on any other date that dropped this class's card from
        // the list outright, unmounting CompletedClassCard together with the local
        // `detailsOpen` state this drawer's `open` prop comes from - so the drawer shut
        // itself mid-publish. The emit alone refetches whatever date is actually selected
        // (via fetchScheduleFilter) and carries the same published change, leaving the card
        // - and this drawer, on its Resources tab - mounted.
        EventRegister.emit('apicall:scheduleHome');
      });
    } else {
      togglePageLoader(true);
      const currentScheduleId = schedule?.occurrenceId || schedule?.occurrence_id || schedule?.occuranceId || schedule?.id || schedule?.scheduleId;
      patchResourceTitle(id, { published: true }, (response, error) => {
        togglePageLoader(false);
        fetchAdminLibraryData(() => {}, { occurrenceId: currentScheduleId });
      });
    }
  };

  const handleUnpublishResource = (id, type) => {
    if (type === 'recording' || type === 'class-recording') {
      togglePageLoader(true);
      const currentScheduleId = schedule?.occurrenceId || schedule?.occurrence_id || schedule?.occuranceId || schedule?.id || schedule?.scheduleId;
      publishBroadcastRecordings(currentScheduleId, false, () => togglePageLoader(false), () => {
        togglePageLoader(false);
        setRecordingPublished(false);
        fetchAdminLibraryData(() => {}, { occurrenceId: currentScheduleId });
        // No fetchSchedule() here, for the same reason as handlePublishResource above: it
        // stomps the list with today's classes, unmounting this class's card and closing the
        // drawer. The emit refreshes the selected date on its own.
        EventRegister.emit('apicall:scheduleHome');
      });
    } else {
      togglePageLoader(true);
      const currentScheduleId = schedule?.occurrenceId || schedule?.occurrence_id || schedule?.occuranceId || schedule?.id || schedule?.scheduleId;
      patchResourceTitle(id, { published: false }, (response, error) => {
        togglePageLoader(false);
        fetchAdminLibraryData(() => {}, { occurrenceId: currentScheduleId });
      });
    }
  };


  const handleDownloadResource = (resource) => {
    // The "..." menu already hides Download for a resource this teacher doesn't own
    // (see ownsResource); this is the same rule at the one place that actually fetches
    // the bytes, so no other caller can route around it.
    if (!ownsResource(resource)) {
      Notification.error("", "You can only download resources you uploaded");
      return;
    }

    const isBroadcastRecording = resource?.type === 'recording' || resource?.roomName;

    if (isBroadcastRecording) {
      const streamId = resource.roomName || schedule?.roomName;
      if (!streamId) return;

      // Use the app's Notification service (top-right) here instead of antd's `message`
      // (top-center) so this lines up with every other snackbar in the app, including
      // the "..." menu's other actions.
      Notification.loading('recording-download', 'Preparing download...');
      getRecordings(streamId, async () => {
        const { recordingsData } = store.getState().broadcast;
        const recording = recordingsData?.[0];
        if (!recording?.downloadurl) {
          Notification.close('recording-download');
          Notification.error("", 'Recording not available for download yet');
          return;
        }
        try {
          const response = await fetch(recording.downloadurl);
          const blob = await response.blob();
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', `${resource.title || 'recording'}.mp4`);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          Notification.close('recording-download');
          Notification.success("", 'Download completed');
        } catch (e) {
          Notification.close('recording-download');
          Notification.error("", 'Failed to download recording');
        }
      });
      return;
    }

    // Locally uploaded resource (video or PDF/lecture-notes) — not a roomName-keyed
    // broadcast recording, so there's no VOD downloadurl to look up. This is the same
    // S3-blob download the Digital Library module already uses for its own content
    // (Viewpdf.js's handleDownload): fetch the file straight off S3 as a blob via axios
    // and hand it to js-file-download. Resolve the S3 key the same way handlePlayResource
    // above does, since the library-contents API has been observed to use different key
    // names depending on how the row was created.
    const rawPath = resource?.filePath || resource?.file || resource?.videoPath ||
      resource?.path || resource?.s3Path || resource?.fileKey || resource?.key;
    if (!rawPath) {
      console.warn('[ScheduleDetailsDrawer] handleDownloadResource: no file path found on resource', resource);
      Notification.error("", 'This file could not be downloaded — no file path found.');
      return;
    }
    const downloadUrl = /^https?:\/\//i.test(rawPath) ? rawPath : `${Api.dlS3Url}${rawPath}`;
    const extMatch = rawPath.match(/\.([a-zA-Z0-9]+)(?:\?.*)?$/);
    const ext = extMatch ? extMatch[1] : (resource?.type === 'video' ? 'mp4' : 'pdf');
    const fileName = `${resource?.title || 'resource'}.${ext}`;

    Notification.loading('resource-download', 'Preparing download...');
    Axios.get(downloadUrl, { responseType: 'blob' })
      .then((res) => {
        if (res?.data) {
          fileDownload(res.data, fileName);
          Notification.close('resource-download');
          Notification.success("", 'Download completed');
        } else {
          Notification.close('resource-download');
          Notification.error("", 'Failed to download resource');
        }
      })
      .catch(() => {
        Notification.close('resource-download');
        Notification.error("", 'Failed to download resource');
      });
  };

  const history = useHistory();


  // `fallbacks` are alternate URLs for the same asset, tried in order by the player
  // if the primary one fails to load - see buildVideoPlaybackUrls below.
  const goToRecordingsPage = (resource, url, fallbacks = []) => {
    setCurrentRecordingPath(url);
    drawerBooleanState('resources');
    const currentScheduleId = schedule?.id || schedule?.scheduleId;
    history.push('/recordings', {
      recordingTitle: resource?.title,
      playbackFallbacks: fallbacks,
      from: {
        path: `${history.location.pathname}${history.location.search}`,
        state: {
          scheduleId: currentScheduleId,
          activeTab: 'resources',
          fromRecordingPlay: true,
          // The schedule list's selected date lives in the `currentDate` prop (redux,
          // see mapStateToProps below) — same source the quiz-navigation flows further
          // down this file already use. history.location.state.currentDate is normally
          // undefined here (the date filter isn't reflected into location state during
          // ordinary browsing), so reading it left this always falling back to today.
          currentDate: currentDate
        }
      }
    });
  };

  // A locally uploaded video is stored on S3 under its raw upload key (`<uuid>.<ext>`,
  // see ResourceAddForm.js's uploadFunction) and then transcoded server-side into a
  // web-playable HLS rendition served from Api.hlsUrl - the same host the Digital
  // Library's own video playback uses (see Viewpdf.js's isHSL branch).
  //
  // Handing the player `Api.dlS3Url + key` instead plays the ORIGINAL uploaded file.
  // That works by accident for formats a browser can decode natively (.mp4) and fails
  // outright for everything transcoding exists to normalise - .flv above all, which no
  // browser can play and which react-player can only attempt via flv.js fetched from a
  // CDN at runtime.
  //
  // So prefer the transcoded rendition and keep the raw-S3 URL as the last resort, so
  // formats that do play directly keep working where a transcode isn't there. The player
  // walks this list on error (see playRecordings.js).
  const WEB_PLAYABLE_EXTENSIONS = ["mp4", "m4v", "webm", "ogg", "ogv", "mov", "m3u8"];
  const buildVideoPlaybackUrls = (rawPath) => {
    if (/^https?:/i.test(rawPath)) return [rawPath];
    const dot = rawPath.lastIndexOf(".");
    const hasExt = dot > rawPath.lastIndexOf("/");
    const base = hasExt ? rawPath.slice(0, dot) : rawPath;
    const ext = hasExt ? rawPath.slice(dot + 1).toLowerCase() : "";
    // Whether the key as-uploaded is something a browser (or hls.js) can decode by
    // itself. If it is not - .flv, .avi, .mkv - react-player falls back to loading
    // flv.js from a CDN, which can hang without ever firing onError and would stall
    // the fallback walk below, so those keys try the transcoded playlist first.
    const playableAsUploaded = WEB_PLAYABLE_EXTENSIONS.includes(ext);
    const transcodedPlaylists = [
      `${Api.hlsUrl}${base}.m3u8`,        // transcoder output keyed by the same name
      `${Api.hlsUrl}${base}/master.m3u8`  // ...or as a playlist folder, as VOD recordings are
    ];
    return playableAsUploaded
      ? [`${Api.hlsUrl}${rawPath}`, ...transcodedPlaylists, `${Api.dlS3Url}${rawPath}`]
      : [...transcodedPlaylists, `${Api.hlsUrl}${rawPath}`, `${Api.dlS3Url}${rawPath}`];
  };

  // Documents open in a full-screen viewer layered over the drawer - not in a browser
  // tab (whose PDF toolbar carries a download button we can't reach) and not on the
  // Digital Library's /digital-library/view-content route either, which would take the
  // user out of the schedule module. Full-screen rather than inside the drawer because
  // the browser fits a PDF to the width it is given: in a ~600px drawer that means a
  // page blown up edge-to-edge with no margins, which is what made it look wrong.
  const handleViewResource = (resource) => {
    // `file` is the field the Digital Library resolves - see ResourcesPanel's handleViewClick.
    const resolvedPath = resource?.file || resource?.filePath;
    const url = resource?.viewUrl ||
      (resolvedPath ? `${Api.dlS3Url}${resolvedPath}` : resource?.link);
    if (!url) {
      console.warn('[ScheduleDetailsDrawer] handleViewResource: no file path found on resource', resource);
      Notification.error("", 'This document could not be opened — no file path found.');
      return;
    }
    
    Notification.loading('pdf-view', 'Loading document...');
    Axios.get(url, { responseType: 'blob' })
      .then((res) => {
        if (res?.data) {
          const blobUrl = window.URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }));
          setPdfPreview({ url: blobUrl, resource });
        } else {
          Notification.error("", 'Failed to load document');
        }
        Notification.close('pdf-view');
      })
      .catch(() => {
        Notification.close('pdf-view');
        // Fallback to direct URL if blob fetch fails
        setPdfPreview({ url, resource });
      });
  };

  const handleClosePdfPreview = () => {
    if (pdfPreview?.url && pdfPreview.url.startsWith('blob:')) {
      window.URL.revokeObjectURL(pdfPreview.url);
    }
    setPdfPreview(null);
  };

  const handlePlayResource = (resource) => {
    // Locally uploaded video (or an admin-library recording row that already has its
    // own stored file) — play the S3 file directly, same URL pattern handleViewClick
    // uses for PDFs. Don't route these through the broadcast VOD lookup below, which
    // is only meaningful for roomName-keyed live-class recordings.
    // The library-contents API has been observed to use slightly different keys for
    // this depending on how the row was created, so check every variant we've seen
    // before falling back to the roomName/broadcast path.
    const resolvedPath = resource?.filePath || resource?.file || resource?.videoPath ||
      resource?.path || resource?.s3Path || resource?.fileKey || resource?.key;
    if (resolvedPath) {
      const [url, ...fallbacks] = buildVideoPlaybackUrls(resolvedPath);
      goToRecordingsPage(resource, url, fallbacks);
      return;
    }
    // A non-YouTube `link` (e.g. an already-absolute URL to the uploaded file) is
    // also directly playable — ResourcesPanel only special-cases YouTube links.
    if (resource?.link) {
      goToRecordingsPage(resource, resource.link);
      return;
    }

    const streamId = resource?.roomName || schedule?.roomName;
    if (!streamId) {
      // Nothing we recognize as a playable path/link, and no roomName to fall back
      // to — log what we actually got so this is diagnosable from the console
      // instead of silently doing nothing.
      console.warn('[ScheduleDetailsDrawer] handlePlayResource: no playable path found on resource', resource);
      Notification.error("", 'This video could not be played — no file path found.');
      return;
    }

    // Notification (top-right) instead of antd's message (top-center) — matches every
    // other snackbar in the app, including the download flow above.
    Notification.loading('recording-play', 'Loading recording...');
    getRecordings(streamId, () => {
      const { recordingsData } = store.getState().broadcast;
      const recording = recordingsData?.[0];
      if (!recording?.url) {
        Notification.close('recording-play');
        Notification.error("", 'Recording not available yet');
        return;
      }
      Notification.close('recording-play');
      goToRecordingsPage(resource, recording.url);
    });
  };


  const [recordingPublished, setRecordingPublished] = useState(!!schedule?.published);

  // A renamed recording's new title lives only on the schedule occurrence
  // (schedule.recordingName) - refetching that via fetchSchedule()/apicall:scheduleHome
  // races the same way the "today stats" fetch used to (see fetchScheduleFilter's
  // skipListUpdate), and even when it wins, this component's `schedule` prop is whatever
  // its parent card captured and doesn't reactively follow the redux update anyway. Hold
  // the just-saved title here and prefer it over schedule?.recordingName immediately,
  // the same way recordingPublished above overrides schedule?.published.
  const [recordingTitleOverride, setRecordingTitleOverride] = useState(null);
  const [recordingTranscodedOverride, setRecordingTranscodedOverride] = useState(null);
  const [recordingSizeOverride, setRecordingSizeOverride] = useState(null);
  const [recordingDurationOverride, setRecordingDurationOverride] = useState(null);
  useEffect(() => {
    const replaced = getReplacedRecording({ roomName: schedule?.roomName, scheduleId: schedule?.id || schedule?.scheduleId });
    setRecordingTitleOverride(replaced?.fileName || null);
    setRecordingTranscodedOverride(null);
    setRecordingSizeOverride(replaced?.fileSize || null);
    setRecordingDurationOverride(replaced?.videoDuration || (replaced?.durationSec ? (replaced.durationSec / 60) : null));
  }, [schedule?.id, schedule?.scheduleId, schedule?.roomName]);

  const [recordingDeleted, setRecordingDeleted] = useState(false);
  useEffect(() => {
    setRecordingDeleted(false);
  }, [schedule?.id, schedule?.scheduleId]);

  // A locally-uploaded video's admin-library row is created by us (ResourceAddForm.js's
  // uploadCompleted2 call) immediately after the chunk-merge, before the backend has
  // actually transcoded it - unlike a class recording, whose row the backend only ever
  // creates once transcoding is already done (see the `transcoded: true` default on
  // recordingsList below). So "it showed up in the refetch" can't be trusted as "it's
  // ready" here the way it can for recordings; track what we just uploaded ourselves and
  // treat those as pending until either the backend confirms transcoded:true for them, or
  // (if the backend never surfaces that for plain video uploads) this times out.
  //
  // Kept in localStorage, not just component state: this drawer remounts fresh on every
  // page load/hard refresh, and re-opening the same class's Resources tab minutes later
  // (still well within a real transcode's runtime) would otherwise lose track of the
  // upload entirely and show it as ready immediately, same as the "still transcoding"
  // class recording section right above it does NOT do (that one's pending state comes
  // from the backend, so it survives refresh on its own).
  const PENDING_TRANSCODE_TIMEOUT_MS = 10 * 60 * 1000; // 10 min - generous upper bound on real transcode time
  const pendingTranscodeStorageKey = (schedId) => `pendingTranscodeUploads:${schedId}`;
  const readPendingTranscodeUploads = (schedId) => {
    if (!schedId) return [];
    try {
      const raw = window.localStorage.getItem(pendingTranscodeStorageKey(schedId));
      const parsed = raw ? JSON.parse(raw) : [];
      const now = Date.now();
      return Array.isArray(parsed) ? parsed.filter(p => p && now - p.addedAt < PENDING_TRANSCODE_TIMEOUT_MS) : [];
    } catch (e) {
      return [];
    }
  };
  const [pendingTranscodeUploads, setPendingTranscodeUploads] = useState(
    () => readPendingTranscodeUploads(schedule?.id || schedule?.scheduleId)
  ); // [{ key, addedAt }]
  useEffect(() => {
    setPendingTranscodeUploads(readPendingTranscodeUploads(schedule?.id || schedule?.scheduleId));
  }, [schedule?.id, schedule?.scheduleId]);
  useEffect(() => {
    const schedId = schedule?.id || schedule?.scheduleId;
    if (!schedId) return;
    try {
      if (pendingTranscodeUploads.length === 0) {
        window.localStorage.removeItem(pendingTranscodeStorageKey(schedId));
      } else {
        window.localStorage.setItem(pendingTranscodeStorageKey(schedId), JSON.stringify(pendingTranscodeUploads));
      }
    } catch (e) {
      // localStorage unavailable/full - the in-memory state above still works for this
      // session, it just won't survive a refresh. Not worth surfacing to the user.
    }
  }, [pendingTranscodeUploads, schedule?.id, schedule?.scheduleId]);

  // Separate from the reset above: this needs to re-run whenever schedule.published
  // itself changes for the SAME schedule too (e.g. after fetchSchedule() refreshes it
  // post publish/unpublish, or picking up a change made from another device/session),
  // not just when switching to a different schedule entirely — otherwise this stays
  // stuck at whatever it was the first time this schedule was opened.
  useEffect(() => {
    setRecordingPublished(!!schedule?.published);
  }, [schedule?.id, schedule?.scheduleId, schedule?.published]);

  // /admin-library/library-contents (fetchAdminLibraryData) returns totalSize and
  // occurance (startTime/endTime) alongside the contents list, but the action only
  // ever extracts `contents`/`items` and drops the rest. A still-virtual broadcast
  // recording (no admin-library row of its own yet, see categorizedResources below)
  // has nowhere else to get its size/duration from, so capture these here from the
  // raw response.
  const [recordingLibraryMeta, setRecordingLibraryMeta] = useState({});
  useEffect(() => {
    setRecordingLibraryMeta({});
  }, [schedule?.id, schedule?.scheduleId]);

  // The virtual class-recording card below (categorizedResources) used to show the
  // scheduled class's length (startTime -> endTime) as its duration, since that's all
  // recordingLibraryMeta/schedule have before an admin-library row exists. That's the
  // class's length, not the recording's — a class can run under/over its slot, and the
  // recording can start/stop at slightly different times. Once we have a roomName we
  // can ask for the actual VOD (same getRecordings() lookup Play/Download already use)
  // and read the real duration off its m3u8, so fetch that here and prefer it once it
  // resolves.
  const parseDurationInMinutes = (val) => {
    if (val == null || val === 'N/A' || val === 0 || val === '0') return null;
    if (typeof val === 'number') {
      if (val > 10000) return val / 60000;
      if (val > 120) return val / 60;
      return val;
    }
    if (typeof val === 'string') {
      if (val.includes(':')) {
        const parts = val.split(':').map(Number);
        if (parts.length === 3) {
          return (parts[0] * 3600 + parts[1] * 60 + parts[2]) / 60;
        }
        if (parts.length === 2) {
          return (parts[0] * 60 + parts[1]) / 60;
        }
      }
      const num = parseFloat(val);
      if (!isNaN(num) && num > 0) {
        if (num > 10000) return num / 60000;
        if (num > 120) return num / 60;
        return num;
      }
    }
    return null;
  };

  const parseSizeInBytes = (val) => {
    if (val == null || val === 0 || val === '0') return null;
    if (typeof val === 'number') return val > 0 ? val : null;
    if (typeof val === 'string') {
      const trimmed = val.trim();
      if (trimmed.toLowerCase().endsWith('mb')) {
        const num = parseFloat(trimmed);
        return (!isNaN(num) && num > 0) ? num * 1024 * 1024 : null;
      }
      if (trimmed.toLowerCase().endsWith('kb')) {
        const num = parseFloat(trimmed);
        return (!isNaN(num) && num > 0) ? num * 1024 : null;
      }
      if (trimmed.toLowerCase().endsWith('gb')) {
        const num = parseFloat(trimmed);
        return (!isNaN(num) && num > 0) ? num * 1024 * 1024 * 1024 : null;
      }
      const num = parseFloat(trimmed);
      return (!isNaN(num) && num > 0) ? num : null;
    }
    return null;
  };

  const replacedRecordingMeta = getReplacedRecording({ roomName: schedule?.roomName, scheduleId: schedule?.id || schedule?.scheduleId });

  const serverDurationMins = parseDurationInMinutes(
    schedule?.fileDuration || schedule?.file_duration || schedule?.recordingDuration || schedule?.videoDuration || schedule?.duration ||
    recordingLibraryMeta?.occurance?.fileDuration || recordingLibraryMeta?.occurance?.videoDuration
  );

  const rawServerSize = parseSizeInBytes(
    schedule?.fileSize || schedule?.file_size || schedule?.recordingSize || schedule?.videoFileSize ||
    recordingLibraryMeta?.occurance?.fileSize
  );
  // Guard: a video size under 10 KB is invalid (e.g. 500 bytes error response / m3u8 playlist text).
  const serverFileSize = (rawServerSize && rawServerSize >= 10240) ? rawServerSize : null;

  const [recordingComputedDuration, setRecordingComputedDuration] = useState(null);
  // ...and the same story for its size, for a slightly different reason.
  // recordingLibraryMeta.totalSize totals up admin-library rows, and this card
  // exists precisely because the recording has no such row - so it was always 0,
  // and the card always read "0 KB" no matter how big the recording actually was
  // (downloading a 54-second one gives a real 102 KB file). Measure it off the
  // same VOD lookup the duration uses instead.
  const [recordingComputedSize, setRecordingComputedSize] = useState(null);
  useEffect(() => {
    setRecordingComputedDuration(null);
    setRecordingComputedSize(null);
    if (!((schedule?.mode === 'Broadcast' || schedule?.mode === 'Online') && isCompletedClass && schedule?.roomName && schedule?.recordCount > 0)) {
      return;
    }
    let cancelled = false;
    let pollTimer = null;

    const measureRecording = () => {
      // If server already has authoritative size/duration (e.g. from an uploaded/replaced video) or local override,
      // do not measure AntMedia VoD which holds the stale old broadcast file.
      if (replacedRecordingMeta?.fileSize || recordingSizeOverride != null) {
        return;
      }
      if ((recordingSizeOverride != null || serverFileSize != null) && (recordingDurationOverride != null || serverDurationMins != null)) {
        return;
      }
      getRecordings(schedule.roomName, () => {
        if (cancelled) return;
        const { recordingsData } = store.getState().broadcast;
        const recording = recordingsData?.[0];
        if (!recording?.url) {
          if (!cancelled) {
            pollTimer = setTimeout(measureRecording, 5000);
          }
          return;
        }

        const durationPromise = (serverDurationMins != null || recordingDurationOverride != null || replacedRecordingMeta?.durationSec)
          ? Promise.resolve(true)
          : getVideoDuration(recording.url)
              .then(({ durationSec, isComplete }) => {
                if (cancelled) return false;
                if (durationSec > 0) {
                  if (recordingDurationOverride == null && serverDurationMins == null && !replacedRecordingMeta?.durationSec) {
                    setRecordingComputedDuration({ minutes: durationSec / 60, isComplete });
                  }
                  setRecordingTranscodedOverride(true);
                  return true;
                }
                return false;
              })
              .catch((err) => {
                console.warn('[ScheduleDetailsDrawer] Video duration not available yet (transcoding in progress)', err);
                return false;
              });

        const sizePromise = (serverFileSize != null || recordingSizeOverride != null || replacedRecordingMeta?.fileSize)
          ? Promise.resolve(true)
          : ((Number(recording.fileSize) >= 10240)
              ? Promise.resolve().then(() => {
                  if (cancelled) return true;
                  if (recordingSizeOverride == null && serverFileSize == null && !replacedRecordingMeta?.fileSize) {
                    setRecordingComputedSize(Number(recording.fileSize));
                  }
                  return true;
                })
              : getVideoSize(recording.url, { downloadUrl: recording.downloadurl })
                  .then((result) => {
                    if (cancelled || !result?.bytes || result.bytes < 10240) return false;
                    if (recordingSizeOverride == null && serverFileSize == null && !replacedRecordingMeta?.fileSize) {
                      setRecordingComputedSize(result.bytes);
                    }
                    return true;
                  })
                  .catch((err) => {
                    console.warn('[ScheduleDetailsDrawer] Video size not available yet (transcoding in progress)', err);
                    return false;
                  }));

        Promise.all([durationPromise, sizePromise]).then(([gotDuration, gotSize]) => {
          if (cancelled) return;
          if (!gotDuration || !gotSize) {
            pollTimer = setTimeout(measureRecording, 5000);
          }
        });
      });
    };

    measureRecording();

    return () => {
      cancelled = true;
      if (pollTimer) clearTimeout(pollTimer);
    };
  }, [schedule?.roomName, schedule?.mode, schedule?.recordCount, isCompletedClass, schedule?.transcoded, schedule?.id, schedule?.scheduleId]);

  // True for the gap between a resource save and the list refetch that follows it —
  // the Resources tab shows a loader for that window instead of the stale pre-save
  // list (which wouldn't yet include what was just added/edited).
  const [resourcesRefreshing, setResourcesRefreshing] = useState(false);

  const [isEdit, setIsEdit] = useState(false);
  const [editType, setEditType] = useState('schedule');
  const [showAddResource, setShowAddResource] = useState(false);
  const [editingResource, setEditingResource] = useState(null);
  const [activeTab, setActiveTab] = useState(
    drawerValue === 'quizzes' ? "quizzes" : drawerValue === 'resources' ? "resources" : "details"
  );
  const [quizzesLoading, setQuizzesLoading] = useState(false);
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
  // The document open in the full-screen viewer, or null when it's closed.
  const [pdfPreview, setPdfPreview] = useState(null);

  const [deleteTarget, setDeleteTarget] = useState(null);
  const [drawerWidth, setDrawerWidth] = useState(window.innerWidth <= 480 ? '100%' : (window.innerWidth <= 1024 ? '80%' : 592));

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 480) {
        setDrawerWidth('100%');
      } else if (window.innerWidth <= 1024) {
        setDrawerWidth('80%');
      } else {
        setDrawerWidth(592);
      }
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // The role x privilege matrix decides resources/quizzes access; see
  // schedulePermissions.js for the table itself. 'none' hides the tab, 'view' shows it
  // read-only, 'edit' allows changes.
  const permissions = useMemo(() => getSchedulePermissions(user), [user]);

  // A Teacher's content rights are scoped to their own classes, so an EDIT grant still
  // has to clear this ownership check. Which users are scoped is the matrix's call, not
  // this component's — permissions.contentScope already answers it, and the answer is
  // NOT "anyone with a privilege": a Teacher holding Admin or Planner stays on their own
  // classes, and only AttendanceMarker widens them to all. This used to read
  // `isSuperAdmin || isAdmin || isPlanner || !isTeacher || isAssignedTeacher`, which had
  // both of those exactly backwards.
  const isAssignedTeacher =
    String(user?.id) === String(schedule?.teacher?.id) ||
    String(user?.id) === String(schedule?.teacherId);
  const teacherScopeSatisfied = permissions.contentScope === 'all' || isAssignedTeacher;

  // Downloading and editing are narrower than the rest of the matrix: a Teacher may act
  // only on the resources they uploaded themselves. Anything a Super Admin (or another
  // teacher) added is still listed, playable and viewable for them - just not theirs to
  // take away or change.
  // The uploader is whoever the admin-library row identifies as the creator - the upload
  // itself sends it as `teacherId` (see digitalLibrary.js's scheduleTeacherId), and
  // resourceUploaderId below reads it back under any of the names the listing uses. Rows
  // created by an admin carry no uploader at all, so an absent/mismatched value withholds
  // the option. Everyone who is not a Teacher is unaffected.
  const isTeacherRole = Boolean(user?.role?.includes?.('Teacher'));
  // The uploader id, whatever library-contents happens to call it on this row. The
  // upload sends it as `teacherId` (digitalLibrary.js's scheduleTeacherId), but the
  // listing does not echo every field back under the name it was sent with — the same
  // response already varies its keys for file path, size and duration, which is why
  // those are resolved by a candidate list too. Reading `teacherId` alone left a
  // teacher's OWN uploads resolving to null, and the rule below then withheld their own
  // Download/Edit — the bug this widens.
  const resourceUploaderId = (resource) => {
    const candidates = [
      resource?.teacherId,
      resource?.teacher_id,
      resource?.uploadedBy,
      resource?.uploadedById,
      resource?.uploaded_by,
      resource?.createdBy,
      resource?.createdById,
      resource?.created_by,
      resource?.addedBy,
      resource?.addedById,
      resource?.userId,
      resource?.user_id,
      resource?.user?.id,
      // Last, and deliberately so: on a recording row `teacher` is the person who took
      // the class, which is not the same question as who uploaded the file. It only gets
      // to answer when nothing more specific is on the row.
      resource?.teacher?.id,
    ];
    // An empty string and null both mean "absent"; a truthiness test would also drop a
    // legitimate id of 0, so test for presence explicitly.
    return candidates.find((v) => v !== undefined && v !== null && v !== '') ?? null;
  };

  const ownsResource = (resource) => {
    if (!isTeacherRole) return true;
    // The virtual class-recording card is built by this drawer for the class in front of
    // the user — it has no admin-library row yet and so carries no uploader field at all.
    // Falling through to the id comparison would deny the assigned teacher their own
    // class recording, so answer it from the class instead.
    if (resource?.isVirtual) return isAssignedTeacher;
    const uploaderId = resourceUploaderId(resource);
    return uploaderId != null && String(uploaderId) === String(user?.id);
  };

  // Ownership is only as good as the field the listing actually returns, and that field
  // is the backend's to name. If a teacher is looking at rows that carry no uploader at
  // all, every Download/Edit disappears and the cause is invisible from the UI - say so
  // here rather than leaving it to be re-diagnosed from the symptom.
  useEffect(() => {
    if (!isTeacherRole) return;
    const rows = adminLibraryList || [];
    if (rows.length === 0) return;
    if (rows.some((r) => resourceUploaderId(r) != null)) return;
    console.warn(
      '[ScheduleDetailsDrawer] No uploader field on any resource row - Download/Edit will be hidden for all of them. Keys present on the first row:',
      Object.keys(rows[0] || {})
    );
  }, [adminLibraryList, isTeacherRole]);
  const isCancelledClass = String(schedule?.status).toLowerCase() === 'cancelled' || String(schedule?.status).toLowerCase() === 'deleted';

  const canUploadContent = permissions.resourcesAccess === ACCESS.EDIT && teacherScopeSatisfied;

  // Read-only whenever the matrix grants view-but-not-edit (Data Operator with no
  // privilege), or when a Teacher is looking at someone else's class.
  const isQuizzesReadOnly = !(permissions.quizzesAccess === ACCESS.EDIT && teacherScopeSatisfied) || isCancelledClass || isCompletedClass;
  const isResourcesReadOnly = !canUploadContent;

  const scheduleMode = schedule?.mode;
  const isOfflineOrOthersMode = scheduleMode === 'Offline' || scheduleMode === 'Others' || scheduleMode === 'Other';
  const isBroadcastMode = scheduleMode === 'Broadcast';
  // Mode and lifecycle no longer hide these tabs - resources and quizzes attach to a
  // class at any point, on any mode. Only an outright 'none' in the matrix (Operation
  // holding AttendanceMarker or Planner) removes them. These used to be
  //   isCompletedClass && isOfflineOrOthersMode
  // which left offline and 'Others' classes with no way to attach material at all.
  const hideResourcesTab = permissions.resourcesAccess === ACCESS.NONE || !teacherScopeSatisfied;
  const hideQuizzesTab = permissions.quizzesAccess === ACCESS.NONE || !teacherScopeSatisfied;
  
  // Attendance is available on every mode - it used to be Offline-only. What hides it now
  // is the matrix: a Data Operator with no privilege has no attendance rights at all. A
  // bare Teacher keeps the tab, because they can mark their own class while it is
  // ongoing; StudentList decides whether the roster is actually editable.
  const hideAttendanceTab = permissions.attendance === ATTENDANCE.NONE;

  useEffect(() => {
    if (activeTab === 'resources' && hideResourcesTab) setActiveTab('details');
    if (activeTab === 'quizzes' && hideQuizzesTab) setActiveTab('details');
    if (activeTab === 'attendance' && hideAttendanceTab) setActiveTab('details');
  }, [activeTab, hideResourcesTab, hideQuizzesTab, hideAttendanceTab]);

  console.log("activeTab- 248", activeTab);


  const displayQuizzes = useMemo(() => {
    console.log('[ScheduleDetailsDrawer] Mapping storeQuizzes to displayQuizzes:', storeQuizzes);
    return (storeQuizzes || []).map((quiz, index) => {
      // Normalize questions count
      const qCount = quiz.questionsCount ??
        quiz.totalQuestions ??
        quiz.questions_count ??
        (Array.isArray(quiz.questions) ? quiz.questions.length : 0);

      // Normalize title
      const qTitle = quiz.name ||
        quiz.title ||
        quiz.quizTitle ||
        quiz.quiz_title ||
        quiz.quizName ||
        (Array.isArray(quiz.quizTitle) ? quiz.quizTitle[0]?.name : null) ||
        'Untitled Quiz';

      return {
        id: quiz.id || quiz.quizId || quiz._id || `quiz-${index}`,
        title: qTitle,
        questionsCount: qCount,
        duration: quiz.timeBound || quiz.timebound || quiz.duration || quiz.timeLimit || quiz.time_limit || null,
        isPublished: quiz.isPublished ?? quiz.published ?? quiz.hasPublishedForBroadcast ?? (quiz.status === 'Published') ?? false,
        ...quiz,
      };
    });
  }, [storeQuizzes]);

  useEffect(() => {
    if (open) {
      if (history.location.state?.activeTab) {
        setActiveTab(history.location.state.activeTab);
      } else if (drawerValue === 'quizzes') {
        setActiveTab('quizzes')
      } else {
        setActiveTab("details");
      }
      setIsEdit(false);
      setEditType('schedule');
      setShowAddResource(false);
      // drawerValue is a one-shot "reopen on this tab" signal (set by
      // goToRecordingsPage / scheduleAddQuiz.js before navigating away).
      // We've just consumed it above — clear it now instead of relying on
      // handleClose to do it later. If the drawer is ever exited any other
      // way (browser back, navigating elsewhere mid-flow, etc.) handleClose
      // never runs, and this flag stays truthy forever — which permanently
      // disables scheduleAdmin's filter bar via its `!!drawerValue` check.
      if (drawerValue) {
        drawerBooleanState('');
      }

      // Clear the native browser history state immediately after consuming it!
      // This ensures that if the user does a hard refresh (F5), the browser
      // won't restore the route state that initially opened the drawer.
      if (history.location.state && window.history.state && window.history.state.state) {
        let browserState = { ...window.history.state.state };
        let stateChanged = false;
        
        ['activeTab', 'scheduleId', 'fromQuizSave', 'fromRecordingPlay'].forEach(key => {
          if (browserState[key] !== undefined) {
            delete browserState[key];
            stateChanged = true;
          }
        });
        
        if (stateChanged) {
          window.history.replaceState({ ...window.history.state, state: browserState }, '');
        }
      }
    }
  }, [open, history.location.state?.activeTab, drawerValue]);

  // Scroll to 0 when activeTab or sub-views change
  useEffect(() => {
    // Wait for the DOM to update
    setTimeout(() => {
      const scrollableElements = document.querySelectorAll(
        '.ant-drawer-wrapper-body, .ant-drawer-body, .schedule-drawer-tabs .ant-tabs-content-holder, .schedule-drawer-tabs .ant-tabs-tabpane'
      );
      scrollableElements.forEach(el => {
        el.scrollTop = 0;
      });
    }, 100);
  }, [activeTab, showAddResource, isEdit]);

  // Fetch quizzes for this broadcast when quizzes tab is active
  const doFetchQuizzes = () => {
    const broadcastId = schedule?.id || schedule?.scheduleId;
    if (!broadcastId) {
      console.error('doFetchQuizzes: NO BROADCAST ID FOUND');
      return;
    }
    setQuizzesLoading(true);
    fetchBroadcastQuizzes(
      broadcastId,
      (response, error) => {
        setQuizzesLoading(false);
        if (error) {
          console.error('Quiz fetch error:', error);
        }
      },
      (quizList) => {
        console.log('Quiz list from server:', quizList);
      }
    );
  };

  // Fetch quizzes when drawer opens or when returning from quiz save.
  // useLayoutEffect (not useEffect) so quizzesLoading flips to true - and QuizzesPanel
  // swaps to its loader - in the same paint as switching to this tab, instead of one
  // frame later. Otherwise the browser gets to paint the previous schedule's quizzes
  // (still sitting in the store from before this fetch) for a moment before the loader
  // replaces them, i.e. exactly the blink this is meant to avoid.
  useLayoutEffect(() => {
    if (open && (activeTab === 'quizzes' || history.location.state?.fromQuizSave)) {
      doFetchQuizzes();
      // clear fromQuizSave flag so subsequent tab changes don't re-trigger — mutated in
      // place rather than history.replace(...), which mints a new location.key and (per
      // root.js's <Switch location={location} key={location?.key}>) would remount the
      // whole routed page; see handleClose's comment below for the full explanation.
      if (history.location.state?.fromQuizSave) {
        history.location.state.fromQuizSave = false;
      }
    }
  }, [open, activeTab, history.location.state?.fromQuizSave]);

  // Track selected subject and class for fetching dependent data
  const [subjectId, setSubjectId] = useState(null);
  const [classId, setClassId] = useState(null);

  // Memoize stable props for ResourceAddForm to prevent infinite loops in its useEffects
  const initialSubId = useMemo(() => schedule?.subject?.id || schedule?.subjectId, [schedule]);
  const initialClassIds = useMemo(() => (schedule?.standards || []).map(b => ({
    id: b.stdId || b.id,
    name: b.std && b.section ? `${b.std}-${b.section}` : (b.standard ? `${b.standard}-${b.std_section}` : b.name)
  })), [schedule]);

  // 1. Discovery Effect: Find chapters/topics if they are missing
  useEffect(() => {
    if (!open || !schedule) return;
    const sub = schedule.subject;
    const std = schedule.standards?.[0];
    const sId = sub?.id || schedule?.subjectId;
    const cId = std?.stdId || std?.id;

    if (sId) setSubjectId(sId);
    if (cId) setClassId(cId);

    if (sId && cId) {
      if (!getChaptersList || getChaptersList.length === 0) {
        fetchAdminChapterFilter('', cId, sId);
      }
    }

    // Update Redux state for subject/standard context
    if (sub) {
      updateCurrentSub({
        subjects_id: sId,
        subjects_name: sub?.name || schedule?.subjectName
      });
    }
    if (std) {
      updateCurrentStd({
        std_id: cId,
        standard: std?.std || std?.standard,
        std_section: std?.section || std?.std_section
      });
    }
    updateSetType('');
  }, [open, schedule?.id]);

  // 2. Data Fetching Effect: Fetch library resources
  // NOTE: We intentionally exclude selectedTopic, selectedChapter, topicList, getChaptersList
  // from deps to prevent spurious re-fetches when the user changes chapter/topic inside
  // ResourceAddForm. The API only filters by occurrenceId (scheduleId) anyway.
  useEffect(() => {
    if (!open || !schedule) return;

    const sId = schedule?.subject?.id || schedule?.subjectId || '';
    const std = schedule?.standards?.[0];
    const cId = std?.stdId || std?.id || '';
    const scheduleId = schedule.id || schedule.scheduleId;

    const fetchParams = {
      subjectId: sId,
      standardId: cId,
      scheduleId,
      topicId: schedule?.topicId,
      chapterId: schedule?.chapterId,
      silent: true,
    };

    console.log('[ScheduleDetailsDrawer] Fetching library data with:', fetchParams);
    fetchAdminLibraryData((response) => {
      setRecordingLibraryMeta({
        totalSize: response?.totalSize,
        occurance: response?.occurance
      });
    }, fetchParams);

  }, [open, schedule?.id]);

  // 2b. Refetch when the Resources tab is opened, using the real topicId/chapterId
  // already known for this occurrence (e.g. from a resource uploaded earlier this
  // session) rather than the topic-less initial fetch above.
  useEffect(() => {
    if (!open || !schedule || activeTab !== 'resources') return;

    const sId = schedule?.subject?.id || schedule?.subjectId || '';
    const std = schedule?.standards?.[0];
    const cId = std?.stdId || std?.id || '';
    const scheduleId = schedule.id || schedule.scheduleId;
    const currentOccurrenceId = schedule?.occurrenceId || schedule?.occuranceId || scheduleId;

    const existing = (adminLibraryList || []).find(item => {
      const itemSchedId = item?.occurrenceId || item?.occurrence_id || item?.occuranceId || item?.scheduleId || item?.broadcastId || item?.schedule_id || item?.broadcast_id;
      return itemSchedId && String(itemSchedId) === String(currentOccurrenceId);
    });

    const topicId = existing?.topicId || schedule?.topicId;
    const chapterId = existing?.chapterId || schedule?.chapterId;
    if (!topicId || !chapterId) return; // nothing real to filter by yet — avoid a guaranteed "Topic not found"

    fetchAdminLibraryData(null, {
      subjectId: sId,
      standardId: cId,
      scheduleId,
      topicId,
      chapterId,
    });
  }, [open, schedule?.id, activeTab]);

  // Handle resource save — always refetch by schedule-level IDs so all uploaded
  // resources appear regardless of which chapter/topic was selected in the form.
  const handleResourceSave = (payload) => {
    console.log('RESOURCE SAVED 👉', payload);

    const sId = schedule?.subject?.id || schedule?.subjectId || '';
    const std = schedule?.standards?.[0];
    const cId = std?.stdId || std?.id || '';
    const scheduleId = schedule?.id || schedule?.scheduleId || '';

    // A freshly-uploaded local video (not a YouTube link, not an edit of something
    // already in the list) needs the same "pending transcode" treatment recordings
    // get - see pendingTranscodeUploads above. ResourceAddForm.js sends the merge
    // fileKey through specifically so it can be matched against the refetched item.
    if (payload?.type === 'video' && payload?.fileKey && !payload?.youtubeLink) {
      setPendingTranscodeUploads(prev => [...prev, { key: payload.fileKey, addedAt: Date.now() }]);
    }

    // Switch back to the list view right away, but keep it in a loading state until
    // the refetch below resolves — otherwise the list would flash the stale pre-save
    // data (missing what was just added/edited) for however long the refetch takes.
    setShowAddResource(false);
    setEditingResource(null);
    setResourcesRefreshing(true);

    // Refresh the full resource list for this schedule.
    // The API filters by occurrenceId (scheduleId) — chapter/topic are not needed.
    fetchAdminLibraryData((response) => {
      console.log('Resource list refreshed after save:', response);
      setResourcesRefreshing(false);
    }, {
      subjectId: sId,
      standardId: cId,
      scheduleId,
      topicId: payload?.topicId || schedule?.topicId,
      chapterId: payload?.chapterId || schedule?.chapterId,
    });

    // A class recording's card (when it has no admin-library row of its own — see
    // categorizedResources above) gets its title straight from `schedule.recordingName`,
    // not from the admin-library refetch above. Renaming it (ResourceAddForm.js's
    // BroadcastRecordingEdit path) updates that name on the schedule occurrence itself.
    // fetchSchedule()+emit below refreshes the underlying redux data for everyone else,
    // but it's still a network round trip racing the same "today vs selected date"
    // staleness fetchScheduleFilter's skipListUpdate was added for, and even once it
    // resolves, this component's `schedule` prop is just whatever its parent card
    // captured — it won't reactively pick up the redux change on its own. Set the
    // optimistic override immediately so the title updates on the very first save
    // instead of needing a second edit (or a lucky refetch timing) to show it.
    if (payload?.type === 'recording') {
      if (payload?.title) setRecordingTitleOverride(payload.title);
      if (payload?.file) setRecordingTranscodedOverride(false);
      if (payload?.size != null) {
        setRecordingSizeOverride(payload.size);
        setRecordingComputedSize(payload.size);
        if (schedule) {
          schedule.fileSize = payload.size;
          schedule.videoFileSize = payload.size;
          schedule.size = payload.size;
        }
      }
      const durMins = payload?.videoDuration != null 
        ? payload.videoDuration 
        : (payload?.durationSec ? payload.durationSec / 60 : (payload?.duration ? payload.duration / 60 : 0));
      if (payload?.videoDuration != null || payload?.durationSec != null || payload?.duration != null) {
        setRecordingDurationOverride(durMins);
        setRecordingComputedDuration({ minutes: durMins, isComplete: true });
        if (schedule) {
          schedule.fileDuration = payload.fileDuration;
          schedule.videoDuration = durMins;
        }
      }
      saveReplacedRecording({
        roomName: schedule?.roomName || payload?.roomName,
        scheduleId: schedule?.id || schedule?.scheduleId,
        fileSize: payload?.size,
        fileDuration: payload?.fileDuration,
        fileName: payload?.title,
        durationSec: payload?.durationSec || payload?.duration,
        videoDuration: durMins
      });
      // Intentionally DO NOT emit apicall:scheduleHome or fetchSchedule here!
      // Emitting it would refetch the schedule list in the parent,
      // which replaces the very object (schedule) this drawer's visible
      // prop comes from, and so slams the drawer shut mid-edit.
    }
  };

  // Helper function to format file size
  const formatFileSize = (bytes) => {
    if (!bytes || bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return Math.round(bytes / Math.pow(k, i)) + ' ' + sizes[i];
  };

  const handleRenameResource = (id, newTitle) => {
    // Use the target resource's own topicId/chapterId (each resource carries the
    // values it was uploaded with) rather than guessing off the schedule/occurrence.
    const target = (adminLibraryList || []).find(r => String(r?.id) === String(id));
    patchResourceTitle(id, newTitle, (response, error) => {
      if (!error && (response?.show?.type === 'success' || response)) {
        // Refresh library data
        fetchAdminLibraryData(null, {
          scheduleId: schedule?.id || schedule?.scheduleId,
          topicId: target?.topicId || schedule?.topicId,
          chapterId: target?.chapterId || schedule?.chapterId
        });
      }
    });
  };

  const handleResourceEdit = (resource) => {
    // Same rule as Download: the menu already hides Edit for a resource this teacher
    // doesn't own, and this stops any other caller opening the form against it.
    if (!ownsResource(resource)) {
      Notification.error("", "You can only edit resources you uploaded");
      return;
    }
    setEditingResource(resource);
    setShowAddResource(true);
  };

  const handleConfirmDelete = async () => {
    if (!deleteTarget) return;

    if (typeof togglePageLoader === 'function') togglePageLoader(true);
    if (deleteTarget.type === 'single') {
      // Class recordings aren't admin-library resources — they live on the broadcast/VOD
      // server keyed by roomName, so they need the same delete API the Recordings modal
      // uses (deleteBroadcastRecording), not deleteResourceContent.
      const isRecording = deleteTarget.resourceType === 'recording' || deleteTarget.resourceType === 'class-recording';

      return new Promise((resolve) => {
        if (isRecording) {
          const roomName = deleteTarget.roomName || schedule?.roomName;
          const completeDeletion = () => {
            setIsDeleteModalVisible(false);
            setDeleteTarget(null);
            setRecordingDeleted(true);
            clearReplacedRecording({ roomName, scheduleId: schedule?.id || schedule?.scheduleId });
            // Deliberately NOT fetchSchedule() here. That refetches /schedule-new/ with no date
            // param - i.e. TODAY's list - and dispatches it straight into the same scheduleList
            // slice the date-filtered Schedule page renders its cards from. For a class on any
            // other date that drops this class's card from the list outright, which unmounts
            // CompletedClassCard, destroys the local `detailsOpen` state this drawer's `open`
            // prop comes from, and so slams the drawer shut mid-delete. The emit below refetches
            // the correct date via fetchScheduleFilter, which picks up the recordCount change
            // just the same while keeping the card - and this drawer, on its Resources tab -
            // mounted. Nothing else needed fetchSchedule: deleting a recording changes neither
            // the occurrence counts nor the modes/todaysActivities slices only it refreshes.
            EventRegister.emit('apicall:scheduleHome');
            fetchAdminLibraryData(() => {}, {
              scheduleId: schedule?.id || schedule?.scheduleId,
              topicId: deleteTarget?.topicId || schedule?.topicId,
              chapterId: deleteTarget?.chapterId || schedule?.chapterId
            });
          };

          // Same (callback, succesCallback) pattern the working Recordings-modal delete
          // flow uses (see offerDeleteModal.js) — callback always fires and just clears
          // the loader; succesCallback only fires on success and does the refresh/close.
          // If the media server reports unable to delete mp4 broadcast (e.g. file is missing or already removed),
          // treat it as cleaned up on the server so the drawer UI reflects the removal.
          deleteBroadcastRecording(roomName, (response) => {
            if (typeof togglePageLoader === 'function') togglePageLoader(false);
            const isMissingBroadcast = response?.show?.type === 'error' && 
              /unable to delete mp4 broadcast/i.test(response?.show?.message || '');
            if (isMissingBroadcast) {
              completeDeletion();
            }
          }, () => {
            completeDeletion();
          });
        } else if (!deleteTarget.id) {
          // No id AND no libraryId on this resource — calling the delete API would just
          // silently no-op against a garbage id, so surface that instead.
          console.warn('[ScheduleDetailsDrawer] handleConfirmDelete: resource has no id/libraryId to delete', deleteTarget);
          Notification.error("", `Could not delete "${deleteTarget.name}" — no resource id found.`);
          if (typeof togglePageLoader === 'function') togglePageLoader(false);
          setIsDeleteModalVisible(false);
          setDeleteTarget(null);
        } else {
          deleteResourceContent(deleteTarget.id, (response, error) => {
            if (!error && (response?.show?.type === 'success' || response)) {
              fetchAdminLibraryData(() => {
                if (typeof togglePageLoader === 'function') togglePageLoader(false);
              }, {
                scheduleId: schedule?.id || schedule?.scheduleId,
                topicId: deleteTarget?.topicId || schedule?.topicId,
                chapterId: deleteTarget?.chapterId || schedule?.chapterId
              });
            } else {
              if (typeof togglePageLoader === 'function') togglePageLoader(false);
              Notification.error("", `Failed to delete "${deleteTarget.name}"`);
            }
            setIsDeleteModalVisible(false);
            setDeleteTarget(null);
          });
        }
        resolve();
      });
    } else if (deleteTarget.type === 'all' || deleteTarget.type === 'bulk') {
      const occurrenceId = schedule?.occurrenceId || schedule?.occuranceId || schedule?.id || schedule?.scheduleId;
      // admin-library's delete-all only clears uploaded PDFs/videos/notes — it never
      // reaches the broadcast/VOD recording, so that needs the same deleteBroadcastRecording
      // API used for a single recording delete, run alongside it.
      const hasRecording = deleteTarget.type === 'bulk' 
        ? deleteTarget.resources?.some(r => r.type === 'recording' || r.type === 'class-recording')
        : categorizedResources.classRecordings?.length > 0;

      if (!occurrenceId && !hasRecording) {
        if (typeof togglePageLoader === 'function') togglePageLoader(false);
        return Promise.resolve();
      }

      const pendingDeletes = [];
      if (deleteTarget.type === 'bulk') {
        if (hasRecording) {
          pendingDeletes.push(new Promise((res) => deleteBroadcastRecording(schedule?.roomName, () => res(), () => {}, true)));
        }
        const regularResources = (deleteTarget.resources || []).filter(r => r.type !== 'recording' && r.type !== 'class-recording');
        regularResources.forEach(r => {
          const id = r.id || r.libraryId;
          if (id) {
            pendingDeletes.push(new Promise((res) => deleteResourceContent(id, res, true)));
          }
        });
      } else {
        if (occurrenceId) {
          pendingDeletes.push(new Promise((res) => postDeleteAllResources(occurrenceId, () => res())));
        }
        if (hasRecording) {
          pendingDeletes.push(new Promise((res) => deleteBroadcastRecording(schedule?.roomName, () => res(), () => {}, true)));
        }
      }

      return Promise.all(pendingDeletes).then(() => {
        if (deleteTarget.type === 'bulk') {
          Notification.success("", "Content Deleted successfully!");
        }
        if (hasRecording) {
          setRecordingDeleted(true);
          // Deliberately NOT fetchSchedule() here. That refetches /schedule-new/ with no date
          // param - i.e. TODAY's list - and dispatches it straight into the same scheduleList
          // slice the date-filtered Schedule page renders its cards from. For a class on any
          // other date that drops this class's card from the list outright, which unmounts
          // CompletedClassCard, destroys the local `detailsOpen` state this drawer's `open`
          // prop comes from, and so slams the drawer shut mid-delete. The emit below refetches
          // the correct date via fetchScheduleFilter, which picks up the recordCount change
          // just the same while keeping the card - and this drawer, on its Resources tab -
          // mounted. Nothing else needed fetchSchedule: deleting a recording changes neither
          // the occurrence counts nor the modes/todaysActivities slices only it refreshes.
          EventRegister.emit('apicall:scheduleHome');
        }
        const fallbackId = schedule?.id || schedule?.scheduleId || '';
        fetchAdminLibraryData(() => {
          if (typeof togglePageLoader === 'function') togglePageLoader(false);
        }, {
          scheduleId: schedule?.id || schedule?.scheduleId,
          topicId: schedule?.topicId || schedule?.topic_id || schedule?.syllabus?.topicId || schedule?.topic?.id || fallbackId,
          chapterId: schedule?.chapterId || schedule?.chapter_id || schedule?.syllabus?.chapterId || schedule?.chapter?.id || fallbackId
        });
        setIsDeleteModalVisible(false);
        setDeleteTarget(null);
      });
    }
  };

  // Map flat adminLibraryList to ResourcesPanel categories
  const categorizedResources = useMemo(() => {
    const list = adminLibraryList || [];
    const currentScheduleId = schedule?.occurrenceId || schedule?.occurrence_id || schedule?.occuranceId || schedule?.id || schedule?.scheduleId;

    // Helper to check type safely
    const isType = (item, typeStr) => {
      const t = (item?.type || '').toLowerCase();
      const s = typeStr.toLowerCase();
      return t === s || t === s.replace('-', '_') || t === s.replace('_', '-');
    };

    const isVideoLike = (item) => Boolean(
      item?.link ||
      item?.videoType ||
      isType(item, 'video') ||
      isType(item, 'youtube') ||
      isType(item, 'recording') ||
      isType(item, 'class-recording')
    );

    const isPdfLike = (item) => Boolean(
      isType(item, 'lecture-notes') ||
      isType(item, 'pdf') ||
      isType(item, 'notes') ||
      (!isVideoLike(item) && (item?.file || item?.filePath))
    );

    // Is this item one of our own recent local-video uploads still waiting on
    // transcoding? The refetched admin-library row doesn't carry the fileKey we
    // uploaded it under by any single consistent field name, so check the few
    // candidates it could come back as. Expires after PENDING_TRANSCODE_TIMEOUT_MS
    // so a video the backend never flags transcoded:true for doesn't stay stuck
    // "pending" forever.
    const now = Date.now();
    const activePendingKeys = pendingTranscodeUploads
      .filter(p => now - p.addedAt < PENDING_TRANSCODE_TIMEOUT_MS)
      .map(p => p.key);
    const isPendingLocalUpload = (item) => {
      if (activePendingKeys.length === 0) return false;
      const candidates = [item?.file, item?.filePath, item?.fileKey, item?.fileName, item?.file_name];
      return candidates.some(c => c && activePendingKeys.includes(c));
    };

    // What the backend actually says about a video row's transcode state, or undefined
    // when it says nothing at all. library-contents rows for plain video uploads don't
    // carry this flag - that's exactly why recordingsList below has to hard-default
    // `transcoded: true` - so a missing field must NOT be read as "still transcoding",
    // or every locally uploaded video stays stuck on the "being transcoded" message
    // forever, long past the pending window above. Only an explicit false counts.
    const backendTranscoded = (item) =>
      [item?.transcoded, item?.isTranscoded, item?.transcodeCompleted, item?.is_transcoded]
        .find(v => v === true || v === false);

    // Filter resources by current scheduleId to prevent leakage
    const filteredList = list.filter(item => {
      const itemSchedId = item?.occurrenceId || item?.occurrence_id || item?.occuranceId || item?.scheduleId || item?.broadcastId || item?.schedule_id || item?.broadcast_id;
      // If item has a schedule ID, it MUST match the current one
      if (itemSchedId) {
        return String(itemSchedId) === String(currentScheduleId);
      }
      // If item has no schedule ID, it might be a global resource (optional: show or hide)
      // For now, we'll keep it to maintain compatibility, but prioritized filtering is key.
      return true;
    });

    const recordingsList = filteredList.filter(r => r && (isType(r, 'recording') || isType(r, 'class-recording'))).map(r => {
      const rowSize = [r.size, r.videoFileSize, r.fileSize, r.sizeInBytes, r.file_size].find(v => !!v) || 0;
      const rowDuration = [r.videoDuration, r.duration, r.video_duration, r.durationInMinutes, r.fileDuration].find(v => !!v) || 0;
      const isTarget = !editingResource || (String(r.id) === String(editingResource.id) || String(r.libraryId) === String(editingResource.libraryId));
      const replacedMeta = getReplacedRecording({ roomName: schedule?.roomName, scheduleId: currentScheduleId });
      
      const effectiveSize = (recordingSizeOverride != null && isTarget)
        ? recordingSizeOverride
        : (replacedMeta?.fileSize
          ? replacedMeta.fileSize
          : (serverFileSize != null ? serverFileSize : rowSize));

      const effectiveDuration = (recordingDurationOverride != null && isTarget)
        ? recordingDurationOverride
        : (replacedMeta?.videoDuration != null
          ? replacedMeta.videoDuration
          : (serverDurationMins != null ? serverDurationMins : rowDuration));

      return {
        ...r,
        id: r.id,
        type: 'video',
        title: (recordingTitleOverride && isTarget) ? recordingTitleOverride : (replacedMeta?.fileName || r.title || r.name || 'Untitled Recording'),
        size: effectiveSize,
        videoDuration: effectiveDuration,
        thumbnail: null,
        // An admin-library row for a recording only gets created once transcoding
        // has finished, so anything that made it into this list is already playable
        // unless the record itself says otherwise.
        transcoded: (isTarget && recordingTranscodedOverride !== null) ? recordingTranscodedOverride : true,
      };
    });

    // Broadcast recordings live on the separate VOD/recording server (keyed by roomName),
    // not in admin-library, so they never show up in `list` above. If this is a completed
    // Broadcast class and admin-library has no recording entry for it, surface a card here
    // that plays back through the same roomName-based replay flow as "Replay live class".
    // Gated on recordCount > 0 (the same field recordingsModal.js checks) so we don't show
    // a card — and let it "un-delete itself" on refetch — for occurrences that never
    // actually produced a recording, or whose recording was just deleted.
    if ((schedule?.mode === 'Broadcast' || schedule?.mode === 'Online') && isCompletedClass && schedule?.roomName && schedule?.recordCount > 0 && !recordingDeleted && recordingsList.length === 0) {
      // Same recordingName field/transform the Recordings modal uses (see recordingsModal.js),
      // so the name shown here matches the one given while recording. Prefer the optimistic
      // override set right after a successful rename (see recordingTitleOverride above) over
      // the possibly-stale schedule prop.
      const replacedMeta = getReplacedRecording({ roomName: schedule?.roomName, scheduleId: currentScheduleId });
      const recordingName = recordingTitleOverride || replacedMeta?.fileName || schedule?.recordingName?.split('_namespace_')?.join(' ');
      // No admin-library row exists for this recording yet, so it has no size/
      // videoDuration of its own - the closest thing available is totalSize +
      // occurance.startTime/endTime from the library-contents fetch above
      // (captured into recordingLibraryMeta), falling back to the schedule
      // occurrence's own startTime/endTime (same fields other class cards -
      // completedClassCard.js etc. - diff the same way) if that hasn't loaded yet.
      const recStartTime = recordingLibraryMeta?.occurance?.startTime || schedule?.startTime;
      const recEndTime = recordingLibraryMeta?.occurance?.endTime || schedule?.endTime;
      const scheduledClassDurationMins = (recStartTime && recEndTime)
        ? Math.round(moment.duration(moment(recEndTime, 'HH:mm:ss').diff(moment(recStartTime, 'HH:mm:ss'))).asMinutes())
        : 0;

      // scheduledClassDurationMins is the class's slot length, not the recording's -
      // recordingComputedDuration (fetched from the real m3u8, see the effect above) is
      // the actual answer once it resolves, so prefer it and only fall back to the
      // class-slot estimate while that fetch is still pending/unavailable.
      const recordingDurationMins = recordingDurationOverride != null
        ? recordingDurationOverride
        : (replacedMeta?.videoDuration != null
          ? replacedMeta.videoDuration
          : (serverDurationMins != null
            ? serverDurationMins
            : (recordingComputedDuration ? recordingComputedDuration.minutes : scheduledClassDurationMins)));

      const effectiveRecordingSize = recordingSizeOverride != null
        ? recordingSizeOverride
        : (replacedMeta?.fileSize
          ? replacedMeta.fileSize
          : (serverFileSize != null
            ? serverFileSize
            : ((recordingComputedSize && recordingComputedSize >= 10240) ? recordingComputedSize : 0)));

      recordingsList.push({
        id: `class-recording-${currentScheduleId}`,
        type: 'recording',
        title: recordingName || `Class Recording - ${moment(schedule?.date).format('DD MMM YYYY')}`,
        roomName: schedule?.roomName,
        subject: schedule?.subject,
        scheduleData: schedule,
        published: recordingPublished,
        isVirtual: true,
        // recordingComputedSize is measured off the real recording (see the effect
        // above); totalSize can only be non-zero once an admin-library row exists,
        // which for this card it doesn't.
        size: effectiveRecordingSize,
        videoDuration: recordingDurationMins,
        // No admin-library row exists for it yet, but the occurrence itself already
        // knows whether transcoding has finished (the same flag recordingsModal.js reads) —
        // trust that unless we just explicitly uploaded a new video over it.
        transcoded: recordingTranscodedOverride !== null ? recordingTranscodedOverride : !!schedule?.transcoded
      });
    }

    // Tagged here rather than inside each map below: the four object literals spread the
    // raw row in different orders, and these flags have to win over it in all of them.
    const withDownloadRights = (items) =>
      items.map(item => ({
        ...item,
        showDownload: ownsResource(item),
        showEdit: ownsResource(item),
      }));

    return {
      classRecordings: withDownloadRights(recordingsList),
      aiGenerated: withDownloadRights(filteredList.filter(r => r && (isType(r, 'ai-notes') || isType(r, 'ai-generated'))).map(r => ({
        id: r.id,
        type: 'notes',
        title: r.title || r.name || 'AI Summary',
        size: [r.size, r.fileSize, r.sizeInBytes, r.file_size, r.videoFileSize].find(v => !!v) || 0,
        documentPages: r.documentPages || 0,
        ...r
      }))),
      pdfs: withDownloadRights(filteredList.filter(r => r && isPdfLike(r)).map(r => ({
        id: r.id,
        type: 'pdf',
        title: r.title || r.name || 'Untitled Document',
        size: [r.size, r.fileSize, r.sizeInBytes, r.file_size, r.videoFileSize].find(v => !!v) || 0,
        documentPages: r.documentPages || 0,
        ...r
      }))),
      videos: withDownloadRights(filteredList.filter(r => r && isVideoLike(r) && !isType(r, 'recording') && !isType(r, 'class-recording')).map(r => ({
        // Spread the raw item FIRST, then override below — id/type/title/size/videoDuration
        // must win over whatever's on `r`, otherwise a raw field present-but-falsy (e.g.
        // r.videoDuration: 0) silently clobbers the computed fallback that follows it.
        ...r,
        id: r.id,
        type: 'video',
        title: r.title || r.name || 'Untitled Video',
        size: [r.size, r.videoFileSize, r.fileSize, r.sizeInBytes, r.file_size].find(v => !!v) || 0,
        // ResourceAddForm.js computes this client-side from the file itself and sends it
        // as `videoDuration` on upload, but library-contents doesn't always echo the field
        // back under that exact name — check the variants a few other duration-bearing
        // records in this codebase use before giving up and showing nothing.
        videoDuration: [r.videoDuration, r.duration, r.video_duration, r.durationInMinutes].find(v => !!v) || 0,
        thumbnail: null,
        // If this row is one of our own recent uploads (see isPendingLocalUpload above),
        // force it pending - same "not playable until it finishes" gating recordings get,
        // just sourced client-side instead of from the backend for this content type.
        // Past that window only an explicit transcoded:false keeps it pending (see
        // backendTranscoded above); a row carrying no flag at all is treated as ready,
        // since that's all library-contents ever returns for local video uploads.
        transcoded: isPendingLocalUpload(r) ? false : (backendTranscoded(r) !== false)
      })))
    };
  }, [adminLibraryList, schedule?.id, schedule?.scheduleId, isCompletedClass, recordingPublished, recordingDeleted, recordingLibraryMeta, recordingTitleOverride, recordingSizeOverride, recordingDurationOverride, pendingTranscodeUploads, recordingComputedDuration, recordingComputedSize, isTeacherRole, user?.id, recordingTranscodedOverride, schedule?.transcoded, schedule?.mode, schedule?.roomName, schedule?.recordCount]);

  const handleClose = () => {
    setIsEdit(false);
    handleClosePdfPreview();
    drawerBooleanState('')
    // Clear quizzes from redux to prevent cross-schedule data leakage
    fetchBroadcastQuizzes(null, null, (list) => {}); // Passing null or empty could be handled
    // Better: use the actual clear/set action
    if (typeof setBroadcastQuizzes === 'function') {
      setBroadcastQuizzes([]);
    }
    
    if (history.location.state) {
      // Mutate location.state in place instead of history.replace(pathname, newState).
      // history v4's push/replace ALWAYS mints a brand-new location.key (there's no way
      // to pass one through — see history/cjs/history.js's push/replace, both call
      // createLocation(path, state, createKey(), ...) unconditionally), and root.js keys
      // its top-level route Switch on that: <Switch location={location} key={location?.key}>.
      // So this replace() — even though the pathname never changes — was remounting the
      // entire routed page on every drawer close, wiping ScheduleAdmin's local state
      // (including whatever date the user had picked in the filter) back to its
      // just-mounted defaults. Clearing these keys on the existing state object keeps
      // the same location.key, so nothing remounts, while still stopping stale
      // scheduleId/activeTab/fromQuizSave/fromRecordingPlay from affecting later renders.
      delete history.location.state.activeTab;
      delete history.location.state.scheduleId;
      delete history.location.state.fromQuizSave;
      delete history.location.state.fromRecordingPlay;
    }
    onClose();
    setActiveTab("details");
  };

  return (
    <>
      {open && (
        <div
          onClick={(e) => {
            e.stopPropagation();
            handleClose();
          }}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'rgba(0,0,0,0.45)',
            zIndex: 99998
          }}
        />
      )}

      <Drawer
        zIndex={99999}
        placement="right"
        width={drawerWidth}
        className="scaled-drawer"
        open={open}
        mask={false}
        keyboard={true}
        destroyOnClose
        onClose={handleClose}
        closeIcon={null}
        title={null}
        headerStyle={{
          padding: 0,
          border: 'none',
          minHeight: 0,
          height: 0
        }}
        bodyStyle={{
          padding: 0,
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
          overflow: 'hidden'
        }}
      >
        {/* Custom Header with Close Icon */}
        <div
          style={{
            padding: '10px 24px 0',
            // borderBottom: '1px solid #E6E6E6',
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            position: 'relative',
            zIndex: 1000
          }}
        >
          <CloseOutlined
            onClick={(e) => {
              e.stopPropagation();
              handleClose();
            }}
            style={{
              fontSize: 20,
              color: '#999999',
              cursor: 'pointer',
              padding: '4px 8px',
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          />
        </div>

        <Tabs
          activeKey={activeTab}
          onChange={(key) => {
            setActiveTab(key);
            setShowAddResource(false);
            setIsEdit(false);
          }}
          style={{
            marginTop: 0,
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden'
          }}
          tabBarStyle={{
            margin: 0,
            padding: 0,
            borderBottom: '1px solid #E6E6E6'
          }}
          className="schedule-drawer-tabs"
        >
          <TabPane tab="Details" key="details" style={{ height: '100%', overflow: 'hidden' }}>
            {!isEdit ? (
              <ScheduleDetailsTab
                schedule={schedule}
                onEdit={(type = 'schedule') => {
                  setEditType(type);
                  setIsEdit(true);
                }}
                onClose={handleClose}
                togglePageLoader={togglePageLoader}
                pageLoader={pageLoader}
                isCompletedClass={isCompletedClass}
                isOngoingClass={isOngoingClass}
                isCancelledClass={isCancelledClass}
              />
            ) : (
              <ScheduleEditTab
                schedule={schedule}
                editType={editType}
                onCancel={() => setIsEdit(false)}
                onSave={(payload) => {
                  setIsEdit(false);
                }}
                togglePageLoader={togglePageLoader}
                pageLoader={pageLoader}
              />
            )}
          </TabPane>

          {!hideResourcesTab && (
          <TabPane tab="Resources" key="resources" style={{ height: '100%', overflow: 'hidden', display: activeTab === 'resources' ? 'flex' : 'none', flexDirection: 'column' }}>
            {!showAddResource ? (
              <ResourcesPanel
                showTabs={false}
                isReadOnly={isResourcesReadOnly}
                loading={resourcesRefreshing}
                classRecordings={categorizedResources.classRecordings}
                aiGenerated={categorizedResources.aiGenerated}
                pdfs={categorizedResources.pdfs}
                videos={categorizedResources.videos}
                onDownload={handleDownloadResource}
                onPublish={handlePublishResource}
                onUnpublish={handleUnpublishResource}
                onDelete={(resource) => {
                  setDeleteTarget({
                    type: 'single',
                    // libraryId is the same fallback ResourceAddForm.js's edit/save flows
                    // already rely on for admin-library resources (id isn't always
                    // populated). Falling back further to resource.title (as this used
                    // to) sent the title string as the delete API's `id` param instead —
                    // the backend can't match that to anything, so the delete silently
                    // no-ops. That's exactly why this worked for recordings (deleted by
                    // roomName, a completely different path) but not locally uploaded
                    // videos.
                    id: resource.id || resource.libraryId,
                    name: resource.title,
                    resourceType: resource.type,
                    roomName: resource.roomName
                  });
                  setIsDeleteModalVisible(true);
                }}
                onDeleteAll={(deletableResources) => {
                  const totalResources = (categorizedResources.classRecordings?.length || 0) + 
                                         (categorizedResources.aiGenerated?.length || 0) + 
                                         (categorizedResources.pdfs?.length || 0) + 
                                         (categorizedResources.videos?.length || 0);
                  
                  if (deletableResources && deletableResources.length < totalResources) {
                    setDeleteTarget({ type: 'bulk', resources: deletableResources });
                  } else {
                    setDeleteTarget({ type: 'all' });
                  }
                  setIsDeleteModalVisible(true);
                }}
                onRename={handleRenameResource}
                onEdit={handleResourceEdit}
                onPlay={handlePlayResource}
                onView={handleViewResource}
                onAddResource={() => {
                  setEditingResource(null);
                  setShowAddResource(true);
                  // Refresh available storage right before showing the add-resource form —
                  // same as uploadModel.js does for the Course/Library upload flows — so the
                  // over-storage check below is comparing against current, not stale, space.
                  getStorageDetails();
                }}
              />
            ) : (
              <ResourceAddForm
                broadcastId={schedule?.occurrenceId || schedule?.occurrence_id || schedule?.occuranceId || schedule?.id || schedule?.scheduleId}
                roomName={schedule?.roomName}
                initialSubId={initialSubId}
                initialClassIds={initialClassIds}
                initialData={editingResource}
                subjectList={subjects || []}
                classList={getStdList || []}
                chapterList={getChaptersList || []}
                topicList={topicList || []}
                togglePageLoader={togglePageLoader}
                pageLoader={pageLoader}
                sizeOfContents={sizeOfContents}
                // Redux actions
                subjectFilter={subjectFilter}
                fetchClasslist={fetchClasslist}
                fetchAdminChapterFilter={fetchAdminChapterFilter}
                fetchFilterTopic={fetchFilterTopic}
                postCreateTopic={postCreateTopic}
                uploadBlock2={uploadBlock2}
                MergeChunk={MergeChunk}
                uploadCompleted2={uploadCompleted2}
                uploadlecturenotes={uploadlecturenotes}
                removemodel={removemodel}
                patchResourceTitle={patchResourceTitle}
                BroadcastRecordingEdit={BroadcastRecordingEdit}
                uploadRecordingChunk={uploadRecordingChunk}
                mergeRecordingChunks={mergeRecordingChunks}
                updateRecordingCount={updateRecordingCount}
                deleteBroadcastRecording={deleteBroadcastRecording}
                deleteResourceContent={deleteResourceContent}
                onSubjectChange={(id) => {
                  setSubjectId(id);
                  setClassId(null);
                }}
                onClassChange={(id) => {
                  setClassId(id);
                }}
                onFetchClasses={(subjectId) => {
                  console.log('Fetching classes for subject:', subjectId);
                  fetchClasslist(subjectId, '');
                }}
                onFetchChapters={(classId) => {
                  if (classId && subjectId) {
                    fetchAdminChapterFilter('', classId, subjectId);
                  }
                }}
                onFetchTopics={(chapterId) => {
                  if (chapterId && subjectId && classId) {
                    fetchFilterTopic(subjectId, classId, chapterId);
                  }
                }}
                onSave={handleResourceSave}
                onCancel={() => {
                  setShowAddResource(false);
                  setEditingResource(null);
                }}
              />
            )}
          </TabPane>
          )}

          {!hideQuizzesTab && (
          <TabPane tab="Quizzes" key="quizzes">
            <QuizzesPanel
              scheduleId={schedule?.occurrenceId || schedule?.occurrence_id || schedule?.occuranceId || schedule?.id || schedule?.scheduleId}
              quizzes={displayQuizzes}
              loading={quizzesLoading}
              isReadOnly={isQuizzesReadOnly}
              onAddQuiz={() => {
                const broadcastId = schedule?.occurrenceId || schedule?.occurrence_id || schedule?.occuranceId || schedule?.id || schedule?.scheduleId;
                if (broadcastId) {
                  history.push("/schedule/quiz", {
                    scheduleId: broadcastId,
                    existingQuizzes: displayQuizzes,
                    currentDate: currentDate
                  });
                }
              }}
              onEdit={(quiz) => {
                const bId = schedule?.occurrenceId || schedule?.occurrence_id || schedule?.occuranceId || schedule?.id || schedule?.scheduleId;
                if (bId) {
                  history.push("/schedule/quiz", {
                    scheduleId: bId,
                    isEdit: true,
                    initialData: quiz,
                    existingQuizzes: displayQuizzes,
                    currentDate: currentDate
                  });
                }
              }}
              onDeleteAll={() => {
                const bId = schedule?.occurrenceId || schedule?.occurrence_id || schedule?.occuranceId || schedule?.id || schedule?.scheduleId;
                if (bId) postDeleteAllQuizzes(bId);
              }}
              onDelete={(id) => {
                const bId = schedule?.occurrenceId || schedule?.occurrence_id || schedule?.occuranceId || schedule?.id || schedule?.scheduleId;
                postDeleteSingleQuiz(id, bId);
              }}
              onPublish={(id) => {
                const bId = schedule?.occurrenceId || schedule?.occurrence_id || schedule?.occuranceId || schedule?.id || schedule?.scheduleId;
                if (bId) patchBroadcastQuizPublish(id, bId, true, null, () => fetchBroadcastQuizzes(bId));
              }}
              onUnpublish={(id) => {
                const bId = schedule?.occurrenceId || schedule?.occurrence_id || schedule?.occuranceId || schedule?.id || schedule?.scheduleId;
                if (bId) patchBroadcastQuizPublish(id, bId, false, null, () => fetchBroadcastQuizzes(bId));
              }}
            />
          </TabPane>
          )}

          {!hideAttendanceTab && (
          <TabPane tab="Attendance" key="attendance">
            <StudentListComponent
              activeTab={activeTab}
              schedule={schedule}
              togglePageLoader={togglePageLoader}
              pageLoader={pageLoader}
              isScheduledClass={isScheduledClass}
              isCompletedClass={isCompletedClass}
              isOngoingClass={isOngoingClass}
              isCancelledClass={isCancelledClass}
            />
          </TabPane>
          )}
        </Tabs>

        <style>{`
        .schedule-drawer-tabs .ant-tabs-nav {
          margin-bottom: 0 !important;
          padding: 0 !important;
        }

        .schedule-drawer-tabs .ant-tabs-tab {
          padding: 8px 0 !important;
          margin: 0 !important;
          flex: 1;
          display: flex;
          justify-content: center;
          font-family: 'Roboto', sans-serif !important;
          font-size: 20px !important;
          font-weight: 400 !important;
          color: #636363 !important;
        }

        .schedule-drawer-tabs .ant-tabs-nav-list {
          width: 100%;
        }

        .schedule-drawer-tabs .ant-tabs-tab:hover {
          color: #594099 !important;
        }

        .schedule-drawer-tabs .ant-tabs-tab-active .ant-tabs-tab-btn {
          color: #594099 !important;
          font-weight: 500 !important;
        }

        .schedule-drawer-tabs .ant-tabs-ink-bar {
          background: #594099 !important;
          height: 2px !important;
        }

        /* Close (X) icon: #AEAEAE stroke, 16×16 */
        .scaled-drawer .anticon-close {
          color: #AEAEAE !important;
          font-size: 16px !important;
        }

        .schedule-drawer-tabs .ant-tabs-tab-btn {
          width: 100%;
          text-align: center;
          padding: 0 !important;
          margin: 0 !important;
        }

        .schedule-drawer-tabs .ant-tabs-nav::before {
          border-bottom: none !important;
        }

        .schedule-drawer-tabs .ant-tabs-content-holder {
          flex: 1;
          min-height: 0;
          display: flex;
          flex-direction: column;
          overflow: hidden;
        }

        .schedule-drawer-tabs .ant-tabs-content {
          flex: 1;
          min-height: 0;
          display: flex;
          flex-direction: column;
        }

        .schedule-drawer-tabs .ant-tabs-tabpane {
          flex: 1;
          min-height: 0;
          height: 100%;
          overflow: hidden !important;
        }

        .schedule-drawer-tabs .ant-tabs-tabpane-active {
          display: flex !important;
          flex-direction: column;
        }
      `}</style>
      </Drawer>

      {pdfPreview && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 100000,
            background: '#fff',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '12px 24px', borderBottom: '1px solid #E6E6E6', flexShrink: 0 }}>
            <LeftOutlined style={{ cursor: 'pointer', fontSize: 16, color: '#636363' }} onClick={handleClosePdfPreview} />
            <div style={{ flex: 1, minWidth: 0, fontSize: 16, fontWeight: 500, color: '#191919', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
              {pdfPreview.resource?.title || 'Document'}
            </div>
            {/* The same ownership rule the "..." menu uses: a teacher looking at someone
                else's document gets no download affordance here either. */}
            {ownsResource(pdfPreview.resource) && (
              <div
                style={{ cursor: 'pointer', color: '#1089FF', fontSize: 14, fontWeight: 500, flexShrink: 0, letterSpacing: 0.5 }}
                onClick={() => handleDownloadResource(pdfPreview.resource)}
              >
                DOWNLOAD
              </div>
            )}
          </div>
          {/* Framed the same way the Digital Library's Viewpdf.js frames it, #toolbar=0
              included - that is what suppresses the browser viewer's own download and
              print buttons. Given the full width, the browser lays the page out centred
              on its grey backdrop, which is the presentation the library page shows. */}
          <iframe
            title={pdfPreview.resource?.title || 'Document'}
            width="100%"
            height="100%"
            src={`${pdfPreview.url}#toolbar=0`}
            frameBorder="0"
            style={{ flex: 1, minHeight: 0, border: 'none' }}
          />
        </div>
      )}

      <SavingModal
        visible={isDeleteModalVisible}
        onCancel={() => setIsDeleteModalVisible(false)}
        title="Confirm"
        message={(deleteTarget?.type === 'all' || deleteTarget?.type === 'bulk') ? "Are you sure you want to delete all the resources?" : `Are you sure you want to delete ${deleteTarget?.name}?`}
        confirmText="YES"
        onConfirm={handleConfirmDelete}
      />
    </>
  );
};

const mapStateToProps = (state) => ({
  subjects: state.digitalLibrary?.subjects || [],
  getStdList: state.digitalLibrary?.getStdList || [],
  getChaptersList: state.digitalLibrary?.getChaptersList || [],
  topicList: state.digitalLibrary?.topicList || [],
  adminLibraryList: state.digitalLibrary?.adminLibraryList || [],
  broadcastQuizzes: state.digitalLibrary?.broadcastQuizzes || [],
  selectedTopic: state.digitalLibrary?.selectedTopic || {},
  selectedChapter: state.digitalLibrary?.selectedChapter || {},
  drawerValue: state.schedule?.drawerValue || '',
  currentDate: state.schedule?.currentDate || '',
  user: state.session?.user || {},
  sizeOfContents: state.digitalLibrary?.sizeOfContents || {},
});

const mapDispatchToProps = (dispatch) => ({
  subjectFilter: (subject, callback) => dispatch(subjectFilter(subject, callback)),
  fetchClasslist: (subjectId, callback) => dispatch(fetchClasslist(subjectId, callback)),
  fetchAdminChapterFilter: (name, classid, subjectid, callback) => dispatch(fetchAdminChapterFilter(name, classid, subjectid, callback)),
  fetchFilterTopic: (subjectid, classid, chapterid, callback) => dispatch(fetchFilterTopic(subjectid, classid, chapterid, callback)),
  postCreateTopic: (object, callback, successCallback) => dispatch(postCreateTopic(object, callback, successCallback)),
  uploadBlock2: (params, callback) => dispatch(uploadBlock2(params, callback)),
  MergeChunk: (fileId, callback, succesCallback) => dispatch(MergeChunk(fileId, callback, succesCallback)),
  uploadCompleted2: (object, callback) => dispatch(uploadCompleted2(object, callback)),
  uploadlecturenotes: (object, callback, successCallback, setProgress) => dispatch(uploadlecturenotes(object, callback, successCallback, setProgress)),
  removemodel: () => dispatch(removemodel()),
  updateCurrentSub: (sub) => dispatch(updateCurrentSub(sub)),
  updateCurrentStd: (std) => dispatch(updateCurrentStd(std)),
  fetchAdminLibraryData: (cb, params) => dispatch(fetchAdminLibraryData(cb, params)),
  updateSetType: (type) => dispatch(updateSetType(type)),
  fetchBroadcastQuizzes: (id, cb, scb) => dispatch(fetchBroadcastQuizzes(id, cb, scb)),
  setBroadcastQuizzes: (data) => dispatch(setBroadcastQuizzes(data)),
  deleteBroadcastQuiz: (id) => dispatch(deleteBroadcastQuiz(id)),
  postDeleteSingleQuiz: (id, occurrenceId, cb, scb) => dispatch(postDeleteSingleQuiz(id, occurrenceId, cb, scb)),
  postDeleteAllQuizzes: (bId, cb, scb) => dispatch(postDeleteAllQuizzes(bId, cb, scb)),
  patchBroadcastQuizPublish: (quizId, bId, publish, cb, scb) => dispatch(patchBroadcastQuizPublish(quizId, bId, publish, cb, scb)),
  patchResourceTitle: (id, title, callback) => dispatch(patchResourceTitle(id, title, callback)),
  deleteResourceContent: (id, callback, suppressToast) => dispatch(deleteResourceContent(id, callback, suppressToast)),
  postDeleteAllResources: (occurrenceId, callback) => dispatch(postDeleteAllResources(occurrenceId, callback)),
  getStorageDetails: (callback) => dispatch(getStorageDetails(callback)),
  drawerBooleanState: (value) => dispatch(drawerBooleanState(value)),
  publishBroadcastRecordings: (id, isPublish, callback, successCallback) => dispatch(publishBroadcastRecordings(id, isPublish, callback, successCallback)),
  BroadcastRecordingEdit: (params, callback, successCallback) => dispatch(BroadcastRecordingEdit(params, callback, successCallback)),
  getRecordings: (streamId, callback) => dispatch(getRecordings(streamId, callback)),
  setCurrentRecordingPath: (filepath) => dispatch(setCurrentRecordingPath(filepath)),
  fetchSchedule: (callback) => dispatch(fetchSchedule(callback)),
  deleteBroadcastRecording: (roomName, callback, successCallback, suppressToast) => dispatch(deleteBroadcastRecording(roomName, callback, successCallback, suppressToast)),
  uploadRecordingChunk: (params) => dispatch(uploadRecordingChunk(params)),
  mergeRecordingChunks: (fileId) => dispatch(mergeRecordingChunks(fileId)),
  updateRecordingCount: (params) => dispatch(updateRecordingCount(params)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ScheduleDetailsDrawer);
